import React from "react";
import Loading from "./Loading";

export default function ContainerTitle({ title, loading, ...props }) {
  return (
    <div className="mt-4 clearfix">
      <div className="h1 float-left">{title}</div>
      <Loading isLoading={loading} size="1x" className="ml-2 mt-3" />
    </div>
  );
}
